// 生活方式医学与慢病管理大讲堂文章数据
export interface DajiangtangArticle {
  id: number;
  title: string;
  link: string;
  date: string;
  summary?: string;
  coverImage?: string;
}

export const dajiangtangArticles: DajiangtangArticle[] = [
//   {
//     id: 1,
//     title: '慢性病预防与管理新策略讲座',
//     link: 'https://weixin.qq.com/sph/AETYIpVVt',
//     date: '2024-01-18',
//     summary: '探讨慢性病预防的最新策略和管理方法'
//   },
  {
    id: 1,
    title: '“生活方式医学与慢病管理”大讲堂第一讲：吕晓霞主任主讲《你的日常，就是最好的处方》',
    link: 'https://weixin.qq.com/sph/AETYIpVVt',
    date: '2025-10-9',
    summary: '吕晓霞主任主讲《你的日常，就是最好的处方》'
  },
  {
    id: 2,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第一讲：吕晓霞教授。',
    link: 'https://weixin.qq.com/sph/AN4Fv8f6v',
    date: '2025-10-23',
    summary: '重塑健康范式-生活方式医学的变革力量与文明使命'
  },
  {
    id: 3,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第二讲：王仕昌教授。',
    link: 'https://weixin.qq.com/sph/ABZEDzFn3',
    date: '2025-11-6',
    summary: '践行健康生活方式 做自己健康的第一责任人'
  },
  {
    id: 4,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第三讲：丛琳教授。',
    link: 'https://weixin.qq.com/sph/A1NI0J51Q',
    date: '2025-11-20',
    summary: '阿尔茨海默病基础知识、诊断标准和治疗现状'
  },
  {
    id: 5,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第四讲：李胜利教授。',
    link: 'https://weixin.qq.com/sph/AI3r9X9aF',
    date: '2025-12-5',
    summary: '日积月累的小习惯 不期而遇的脑卒中'
  },
  {
    id: 6,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第五讲：王海石教授。',
    link: 'https://weixin.qq.com/sph/ANh8GJStb',
    date: '2025-12-18',
    summary: '重金属与微量元素'
  },
  {
    id: 7,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第六讲：赵风岭教授。',
    link: 'https://weixin.qq.com/sph/AZMbfsvFO',
    date: '2026-1-1',
    summary: '想法决定健康'
  },
  {
    id: 8,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第七讲：张清华教授。',
    link: 'https://weixin.qq.com/sph/AJW7LCpU2u',
    date: '2026-7-23',
    summary: '健康生活方式 终结老年痴呆'
  },
  {
    id: 9,
    title: '“生活方式医学与慢病管理”大讲堂系列科普讲座第八讲：唐吉友教授。',
    link: 'https://weixin.qq.com/sph/A8o61PPwfp',
    date: '2026-7-23',
    summary: '睡眠优先 健康之源'
  },
];

// 获取所有大讲堂文章
export const getDajiangtangArticles = (): DajiangtangArticle[] => {
  return dajiangtangArticles
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};

// 获取最新的大讲堂文章（用于首页显示）
export const getLatestDajiangtangArticles = (limit = 5): DajiangtangArticle[] => {
  return getDajiangtangArticles().slice(0, limit);
};